import React, { memo } from 'react';
import { orderDataActions } from '@AMIEWEB/Order/Store/Order.redux';
import { useDispatch } from 'react-redux';
import { GridCellParams } from '@mui/x-data-grid';
import { makeStyles } from 'tss-react/mui';
import HistoryIcon from '@mui/icons-material/History';
import { IconButton } from '@mui/material';

const useStyles = makeStyles()({
  link: {
    cursor: 'pointer',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const BonusHistoryRenderer = memo(function BonusHistoryRenderer(props: { param: GridCellParams }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const onHistoryIconClick = () => {
    const orderId = props?.param?.row?.orderId;
    const bonusId = props?.param?.row?.bonusId;
    dispatch(orderDataActions.getOrderBonusChangeHistory({ orderId: orderId, bonusId: bonusId }));
  };
  return (
    <>
      <IconButton className={classes.link} onClick={onHistoryIconClick} disableRipple={true}>
        <HistoryIcon />
      </IconButton>
    </>
  );
});

export const XGridBonusHistoryCell = (props: { param: GridCellParams }) => {
  return <BonusHistoryRenderer {...props} />;
};
